// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1dCml","title":"Images45_title__ID4v6","images":"Images45_images__1xYWR"};